import React from 'react';
import { Styles } from '../styles/courseCategory.js';

const StProgramCategory = (props) => {
    return (
        <Styles>
            <div className="course-category ">
                <ul  className="list-items">
                    {props.types?.map((type, ind) => (
                        <li key={ind} className="check-btn " >
                            <input
                                type="checkbox"
                                id={`${ind}`}
                                onChange={(e) => props.ctgFn(e, type.id)}
                                name={type.name}
                                checked={type.check}
                                style={{ marginRight: "6px", width: "15px", height: "18px", cursor: "pointer",backgroundColor:"white" }}
                            />
                            <span htmlFor={`${ind}`} style={{ cursor: "pointer" }}>{type.name}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </Styles>
    );
}

export default StProgramCategory;
